import { Badge, Box, IconButton, Menu, MenuItem } from '@mui/material'
import useAccessControl from '../hooks/useAccessControl'

const CustomMenu = ({ anchor, anchorOrigin, autoFocus = false, id, transformOrigin, open, onClose, items }) => {
  const { hasAccess } = useAccessControl()

  return (
    <Menu
      anchorEl={anchor}
      anchorOrigin={anchorOrigin}
      autoFocus={autoFocus}
      id={id}
      transformOrigin={transformOrigin}
      open={open}
      onClose={onClose}
    >
      {items.map((item, index) => {
        if (item.rights && !hasAccess(item.rights)) return null

        return (
          <MenuItem key={index} onClick={item.onClick} state={item.state} component={item.component} to={item.to}>
            {item.icon && (
              <IconButton size='large' color='inherit' edge='start' sx={{ mr: 1 }}>
                {item.badgeContent ? (
                  <Badge badgeContent={item.badgeContent} color='error'>
                    {item.icon}
                  </Badge>
                ) : (
                  item.icon
                )}
              </IconButton>
            )}
            <Box component='span'>{item.label}</Box>
          </MenuItem>
        )
      })}
    </Menu>
  )
}

export default CustomMenu
